import { isEmail } from "@/shared/components/user-avatar";

/** Endpoint da foto de um usuário por e-mail (plataforma); `null` quando não há e-mail válido. */
export function getUserPhotoPathByEmail(email?: string | null): string | null {
  if (!isEmail(email)) return null;

  return `/api/plataforma/usuarios/foto?email=${encodeURIComponent(email.trim())}`;
}
